
/* User defined models */
export class PersonDetail {
    FirstName?: string;
    LastName?: string;
    AddressLine1?: string;
    AddressLine2?: string;
    AddressLine3?: string;
    Phone?: string
    Email?: string

    public constructor(firstName?: string, lastName?: string, address1?: string, address2?: string, address3?: string, phone?: string, email?: string)
    {
        this.FirstName = firstName;
        this.LastName = lastName;
        this.AddressLine1 = address1;
        this.AddressLine2 = address2;
        this.AddressLine3 = address3;
        this.Phone = phone;
        this.Email = email; 
    }
}